import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  output,
} from '@angular/core';

import { OptionalAsyncPipe } from '../../../pipes/OptionalAsync.pipe';
import { ActionService } from '../../../services/action/action.service';
import { Menu } from '../../../types/menu.type';
import type { MenuItemType } from '../../../types/menu-item.type';
import type { BadgeItemType } from '../../../types/organization.type';
import { MenuItemComponent } from '../../menu/menu-item/menu-item.component';
import { CollapsiblePanelComponent } from '../collapsible/collapsible-panel.component';

@Component({
  selector: 'evc-dropdown-menu',
  imports: [
    CollapsiblePanelComponent,
    MenuItemComponent,
    OptionalAsyncPipe,
  ],
  templateUrl: './dropdown-menu.component.html',
  styleUrls: ['./dropdown-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DropdownMenuComponent {
  readonly itemClicked = output();
  // todo refactor - should both use itemClicked as a badgeItem isn't always an organization
  readonly organizationClicked = output<BadgeItemType>();

  readonly showDividers = input(false);
  readonly showOnlyBadgeItems = input(false);
  readonly showOnlyMenuItems = input(false);
  readonly showTitle = input(true);
  readonly menuConfig = input<Menu>();
  badgeMenuConfig = input<BadgeItemType[]>([]);

  #destroyRef = inject(DestroyRef);
  #actionService = inject(ActionService);

  trackByKey(index: number, item: MenuItemType): string {
    return `${item.key}-${index}`;
  }

  isItemSelected(item: MenuItemType): boolean {
    return item.selected ?? false;
  }

  handleCollapsibleItemClick(item: MenuItemType, collapsibleItemClicked: MenuItemType): void {
    this.#actionService.handleAction(collapsibleItemClicked, this.#destroyRef);
    item.collapsible?.forEach((collapsibleItem) => {
      collapsibleItem.selected = collapsibleItem.key === collapsibleItemClicked.key;
    });
  }

  handleOrganizationClick(item: BadgeItemType): void {
    this.organizationClicked.emit(item);
  }

  closeMenu(): void {
    this.itemClicked.emit();
  }
}
